import { render, staticRenderFns } from "./ModalEquipesProfissionalVincular.vue?vue&type=template&id=799ae627"
import script from "./ModalEquipesProfissionalVincular.vue?vue&type=script&lang=ts"
export * from "./ModalEquipesProfissionalVincular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports